import { MessageCircle, Phone } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { SensorFinder } from "../components/SensorFinder";
import { LogoMark } from "../components/Logo";
import { PHONE, PHONE_LINK, waLink, WA_DEFAULT_MSG } from "../lib/site";

export default function ContactPage() {
  return (
    <main className="bg-[#08090C] pt-24 sm:pt-32 min-h-screen">
      <Seo
        title="اتصل بنا | حساسات كفرات الرياض — واتساب واتصال مباشر"
        description="تواصل مع حساسات كفرات الرياض عبر واتساب أو الاتصال المباشر على +966540377559 لأي استفسار عن حساسات ضغط الإطارات TPMS."
        path="/contact"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-6">
            اتصل بنا
          </h1>
          <p className="text-slate-300 leading-relaxed text-base sm:text-lg mb-10">
            فريق حساسات كفرات الرياض جاهز للإجابة عن استفسارك ومساعدتك في
            اختيار الحساس المناسب لسيارتك.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5 max-w-3xl mb-16">
          <Reveal>
            <div className="metal-card rounded-3xl p-7 h-full">
              <div className="flex items-center gap-4 mb-5">
                <LogoMark size={44} />
                <div>
                  <div className="font-display font-bold text-white">حساسات كفرات الرياض</div>
                  <div className="font-mono text-[10px] tracking-widest text-slate-500 uppercase">
                    Riyadh Tire Sensors
                  </div>
                </div>
              </div>
              <p className="text-sm text-slate-400 leading-relaxed">
                الرياض، المملكة العربية السعودية — جميع الاستفسارات وطلبات
                الأسعار عبر واتساب أو الاتصال المباشر.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex flex-col gap-4 h-full">
              <a
                href={waLink(WA_DEFAULT_MSG)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-btn"
                className="flex-1 inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white font-bold px-6 py-5 rounded-3xl shadow-[0_4px_24px_rgba(16,185,129,0.4)] transition-all active:scale-[0.98] text-lg"
              >
                <MessageCircle size={22} />
                واتساب: <span dir="ltr" className="font-mono text-base">{PHONE}</span>
              </a>
              <a
                href={PHONE_LINK}
                data-testid="contact-call-btn"
                className="flex-1 inline-flex items-center justify-center gap-3 bg-white/5 hover:bg-white/10 border border-white/15 hover:border-red-500/40 text-white font-bold px-6 py-5 rounded-3xl transition-all active:scale-[0.98] text-lg"
              >
                <Phone size={22} className="text-red-500" />
                اتصال: <span dir="ltr" className="font-mono text-base">{PHONE}</span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
      <div className="bg-[#0E1118] border-t border-white/5">
        <SensorFinder compact />
      </div>
    </main>
  );
}
